import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const dewPoint_IN: typeof valueTypeRenderers.dewPoint_IN = {
  label: () => unitConverter.dewPointInCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.dewPointInCanopy().title(),
      render: (n) => unitConverter.dewPointInCanopy(n).valueAsString(),
    }),
}
